module.exports = __webpack_public_path__ + "static/media/r_dot_5.886828cc.png";